<app-half-background [images]="bdpImages" [shadow]="true" alt="BDP search background">
    <ng-container image-contain> </ng-container>
    <ng-container contain>
        <section class="search content-without-footer">
            <div class="search-form-container container">
                <div class="title-container">
                    <div class="d-flex align-items-center flex-column">
                        <div class="search-logo d-sm-block d-none">
                            <app-facility-logo [height]="'75'" [width]="'450'"></app-facility-logo>
                        </div>
                    </div>
                    <h4 class="mat-headline-5 mb-0 fw-500 text-center" id="welcome-title">
                        Welcome to our customer portal
                    </h4>
                </div>
                <section class="col-12">
                    <form [formGroup]="searchForm" (submit)="saveShipment()">
                        <mat-form-field class="w-100 mb-4">
                            <mat-label class="label-lg text-nowrap">BDP Reference Number</mat-label>
                            <input
                                formControlName="hawbId"
                                id="hawb-id"
                                matInput
                                type="text"
                                class="input-awb"
                                placeholder="Enter BDP Reference Number"
                                maxlength="100"
                            />
                            <mat-error>
                                <app-field-error [field]="'hawbId'" [messageList]="formError['hawbId']">
                                </app-field-error>
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field class="w-100 mb-4">
                            <mat-label class="label-lg text-nowrap">Air Waybill</mat-label>
                            <input
                                formControlName="awb"
                                id="awb"
                                matInput
                                type="text"
                                class="input-awb"
                                placeholder="Please enter your Air Waybill"
                                maxlength="100"
                            />
                            <mat-error>
                                <app-field-error [field]="'awb'" [messageList]="formError['awb']"> </app-field-error>
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field class="w-100 mb-4">
                            <mat-label class="label-lg text-nowrap">$ Amount</mat-label>
                            <input
                                id="amount"
                                formControlName="amount"
                                matInput
                                type="tel"
                                class="input-awb"
                                placeholder="00.00"
                                [imask]="maskAmount"
                                [unmask]="'typed'"
                            />
                            <mat-error>
                                <app-field-error [field]="'amount'" [messageList]="formError['amount']">
                                </app-field-error>
                            </mat-error>
                        </mat-form-field>
                        <button
                            id="save-shipment"
                            matButton="filled"
                            type="submit"
                            class="w-100 my-4"
                            color="primary"
                            [disabled]="searchForm.invalid"
                        >
                            @if (!isLoading) {
                                <span>SUBMIT</span>
                            }
                            @if (isLoading) {
                                <mat-icon class="ms-2" matIconPrefix>
                                    <mat-spinner diameter="24"></mat-spinner>
                                </mat-icon>
                            }
                        </button>
                    </form>
                </section>
            </div>
        </section>
    </ng-container>
</app-half-background>
